import { useContext } from 'react'
import { RemoteAssistanceScreenshotContext } from 'context/remoteAssistance'

const useRemoteAssistanceScreenshot = () => {
  return useContext(RemoteAssistanceScreenshotContext)
}

export default useRemoteAssistanceScreenshot
